import React from "react";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import "./Navbar.scss";
import { Row, Col, Navbar, Badge } from "react-bootstrap";
import { UserRole } from "../../Const";
import { useTranslation } from 'react-i18next'
import { Trans, withTranslation } from 'react-i18next';

const Sidebar = (props) => {
  const { t } = useTranslation();
  const userRole =
    useSelector((state) => state.settings.userRole) || UserRole.normal;

  const isActive = (route) => {
    return route == props.url ? "active" : "";
  };

  return (
    <>
      <Col className="sidebar p-lg-0 col-left-1">
        <Navbar  expand="md" className="p-0">
          <Navbar.Toggle aria-controls="sidebar"></Navbar.Toggle>
          <Navbar.Collapse id="sidebar">
            <div className="w-100 vh-100">
              <div className="py-3">
                <img
                  src="/images/logo.png"
                  width="50"
                  className="brand-img"
                ></img>
                <span className="brand-name">CFDHero</span>
              </div>
              <div className="mt-3">
                <ul>
                  <li className="dashboard-tour">
                    <Link
                      to="/dashboard"
                      className={`${isActive("dashboard")} navbar-row`}
                    >
                      <i className="fas fa-tachometer-alt fa-lg navbar-icon"></i>
                      {t("dashboard")}
                    </Link>
                  </li>
                  <li className="bots-tour">
                    <Link
                      to="/bots"
                      className={`${isActive("bots")} navbar-row`}
                    >
                      <i className="fas fa-robot fa-lg navbar-icon"></i>
                      {t("bots")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/deals"
                      className={`${isActive("deals")} navbar-row deals-page-tour`}
                    >
                      <i className="fas fa-exchange-alt fa-lg navbar-icon"></i>
                      {t("deals")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/portfolio"
                      className={`${isActive("portfolio")} navbar-row portfolio-tour`}
                    >
                      <i className="fas fa-chart-pie fa-lg navbar-icon"></i>
                      {t("portfolio")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/marketplace"
                      className={`${isActive("marketplace")} navbar-row marketplace-tour`}
                    >
                      <i className="fas fa-shopping-cart fa-lg navbar-icon"></i>
                      {t("marketplace")}
                    </Link>
                  </li>

                  {/* <li>
                    <Link
                      to="/terminal"
                      className={`${isActive("terminal")} navbar-row terminal-tour`}
                    >
                      <i className="fas fa-terminal fa-lg navbar-icon"></i>
                      {t("terminal")}
                     
                    </Link>
                  </li> */}

                  {/* <li>
                    <Link
                      to="/price-alert"
                      className={`${isActive("price-alert")} navbar-row price-alert-tour`}
                    >
                      <i className="fas fa-bell navbar-icon"></i>
                      {t("price-alert")}
                    </Link>
                  </li> */}
                </ul>
              </div>
              <div className="contact-group justify-content-center">
                <div className="d-flex justify-content-center">
                  <a
                    href="https://play.google.com/store/apps/details?id=capital.novum.stockhero"
                    target="_blank"
                    style={{ textDecoration: "none" }}
                  >
                    <div className="appstore-sm">
                      <img src="/images/google.png" width={25} />
                    </div>
                  </a>
                  <a
                    href="https://apps.apple.com/us/app/stockhero/id1488574255?ls=1"
                    target="_blank"
                    style={{ textDecoration: "none" }}
                  >
                    <div className="appstore-sm">
                      <i className="fab fa-apple fa-xl"></i>
                    </div>
                  </a>
                </div>
                <div>
                  <a href="/affiliate" style={{ textDecoration: "none" }}>
                    <Row className="appstore">
                      <Col style={{ maxWidth: "25%" }} className="my-auto">
                        <i
                          className="fas fa-share-alt text-white"
                          style={{ fontSize: 22 }}
                        ></i>
                      </Col>
                      <Col style={{ maxWidth: "75%" }}>
                      <Trans>earn-more-affiliate</Trans>
                      </Col>
                    </Row>
                  </a>
                </div>
              </div>
            </div>
          </Navbar.Collapse>
        </Navbar>
        <span className="expand-btn" onClick={props.toggleExpand}>
          <i className="fas fa-angle-left"></i>
        </span>
      </Col>
    </>
  );
};

export default withTranslation(null)(Sidebar);
